import { Button } from "antd";
import { ReactComponent as Plus } from "assets/icons/plus-black.svg";
import { useTranslation } from "react-i18next";

const AddButton = ({ onClick }) => {
  const { t } = useTranslation();

  const renderIcon = () => {
    return <Plus />;
  };

  return (
    <div className="mx-5 mt-4">
      <Button
        block
        className="default-button-with-icon"
        icon={renderIcon()}
        onClick={() => onClick(true)}
      >
        {t("card-page.add-address")}
      </Button>
    </div>
  );
};
export default AddButton;
